<ng-container *ngIf="isAllowed">
  <ecp-loader *ngIf="loading"></ecp-loader>
  <ng-content></ng-content>
</ng-container>

